export default {
  setCookie: function (name, value) {
    const d = new Date();
    d.setFullYear(9999);
    document.cookie = name + '=' + encodeURIComponent(value) + ';' + 'expires=' + d.toUTCString();
  },

  cookieToJSON: function () {
    return document.cookie.split(';').reduce((obj, bit) => {
      const [key, val] = bit.split('=');
      if (key)
        return {
          ...obj,
          [key.trim()]: decodeURIComponent(val.trim()),
        };
      else return obj;
    }, {});
  },

  getCookie: function (name) {
    const cookieObj = this.cookieToJSON();

    return cookieObj[name];
  },

  deleteCookie: function (name) {
    document.cookie = name + '=;' + 'expires=' + new Date().toUTCString();
  },
};
